import { render, staticRenderFns } from "./addPz.vue?vue&type=template&id=307b7a62&scoped=true&"
import script from "./addPz.vue?vue&type=script&lang=js&"
export * from "./addPz.vue?vue&type=script&lang=js&"
import style0 from "./addPz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addPz.vue?vue&type=style&index=1&id=307b7a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b7a62",
  null
  
)

export default component.exports